import { render, staticRenderFns } from "./AddNewInvoiceItemTemplate.vue?vue&type=template&id=25706cfa&"
import script from "./AddNewInvoiceItemTemplate.vue?vue&type=script&lang=js&"
export * from "./AddNewInvoiceItemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports